import type { Size } from './models';

/**
 * Parse dimensions from a string like "360x220"
 */
export function parseDimensions(dimensionString: string): Size | null {
  const match = dimensionString.match(/^(\d+)x(\d+)$/);
  if (!match || !match[1] || !match[2]) {
    return null;
  }

  return {
    width: parseInt(match[1], 10),
    height: parseInt(match[2], 10),
  };
}

/**
 * Parse filename to extract ID and extension
 */
export function parseFilename(filename: string): {
  id: string;
  extension: string;
} | null {
  const match = filename.match(/^([a-f0-9-]+)(\.[a-z]+)$/);
  if (!match || !match[1] || !match[2]) {
    return null;
  }

  return {
    id: match[1],
    extension: match[2],
  };
}

/**
 * Validate a UUID string
 */
export function validate(id: string): boolean {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
}
